import { t } from 'i18next';
import Heading from '../../../atoms/Heading';
import { mergeSx } from '../../../../utils/styles';

const styles = {
  link: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 0.25,
    '& p': {
      color: 'info.100',
      fontSize: 10,
      letterSpacing: '0.5px',
      lineHeight: 1.5,
    },
  },
  title: {
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    paddingRight: 1,
    fontWeight: 600,
  },
  highlighted: {
    color: 'secondary.main',
  },
};

type Props = {
  liveEventsCount?: { count: number };
};

const InPlayHeadings = ({ liveEventsCount }: Props) => {
  return (
    <Heading to='../in-play'>
      <Heading.Title sx={styles.title}>{t('gola.live')}</Heading.Title>
      <Heading.Title sx={mergeSx(styles.title, styles.highlighted)}>{t('gola.inPlay')}</Heading.Title>
      <Heading.Link sx={styles.link}>{t('nEvents', { count: liveEventsCount?.count ?? 0 })}</Heading.Link>
    </Heading>
  );
};

export default InPlayHeadings;
